'use client';

import type {SideMenuListProps as Props} from './typings';

import {capitalize} from '@/utils/helpers/string';
import {StyledSideMenuList, StyledSideMenuListFigure} from './styles';

/**
 * @description mobile side menu list component for both top and second level side menu links
 * @param {object} props component props including html attributes
 * @param {React.ReactNode?} [props.heading] optional heading content for the list
 * @param {React.ReactNode} props.children list items
 * @param {boolean?} props.isTopLevel optional if first list in the top-level menu
 * @param {object} [restUlProps] optional HTML attributes for the `ul` element
 * @return {JSX.Element} rendered component markup
 */
const SideMenuList = ({heading, children, isTopLevel, ...restUlProps}: Props): JSX.Element => {
  return (
    <StyledSideMenuListFigure $isTopLevel={isTopLevel}>
      <figcaption>{heading ? capitalize(heading.toString()) : ''}</figcaption>
      <StyledSideMenuList {...restUlProps}>{children}</StyledSideMenuList>
    </StyledSideMenuListFigure>
  );
};

export default SideMenuList;
